import { render, staticRenderFns } from "./datatables_ikid_graduate.vue?vue&type=template&id=0cbd91b2&"
import script from "./datatables_ikid_graduate.vue?vue&type=script&lang=js&"
export * from "./datatables_ikid_graduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports